import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', position: 'fixed', top: 0, left: 0, width: '100%', background: '#3333331f', zIndex: 9999}}>
      <CircularProgress />
    </div>
  );
};

export default Loader;
